var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPage,"color":_vm.color,"loader":_vm.loader,"width":_vm.width,"height":_vm.height,"container":_vm.container},on:{"update:active":function($event){_vm.isLoading=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }